$(document).ready(function() {
  const urls = JSON.parse(document.body.dataset.urls)
	
	function check_permission() {
		if (Notification.permission === "granted") {
			$('#ask_permission').hide();
		}
	}

	if (("Notification" in window)) {
		function notification() {
			var icon = urls.logo;
			$.getJSON(
				"{% url 'reseller_ticket_notification' %}?users={{ request.user.pk }}&users=0&status=open",
				function(data) {
					$.each(data, function(key, val) {
						var options = {
							body: val.body,
							icon: icon
						}
						var notification = new Notification(val.title, options);
						setTimeout(function() {
							notification.close();
						}, '5000');
					});
				}
			);
		}

		if (Notification.permission === "granted") {
			setInterval(function() {
				notification();
			}, 120000);
		}

		$('#ask_permission').click(function(e) {
			// We need to ask the user for permission
			if (Notification.permission !== 'denied') {
				Notification.requestPermission(function(permission) {
					// If the user accepts, let's create a notification
					if (permission === "granted") {
						notification();
					}
				});
			}
			check_permission();
		});
	}
	check_permission();
});

